import { render, staticRenderFns } from "./MenuPurchase.vue?vue&type=template&id=4f8a1a37&scoped=true&"
import script from "./MenuPurchase.vue?vue&type=script&lang=js&"
export * from "./MenuPurchase.vue?vue&type=script&lang=js&"
import style0 from "./MenuPurchase.vue?vue&type=style&index=0&id=4f8a1a37&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8a1a37",
  null
  
)

export default component.exports